/* eslint-disable react/no-array-index-key */
import P from 'prop-types';
import UniversalContainer from '../universal-container';
import styles from './grid.module.scss';
import ItemComponents from './grid-item-component';

const GridItems = ({
  items,
  disableDefaultProps,
  isBuilderPage,
  outputGridItemIndicator,
  outputDashedBorder,
  fitWidth,
}) => {
  const itemContainerConfig = (item) => ({
    ...item?.itemContainer,
    alignment: {
      ...item?.itemContainer?.alignment,
      type: 'flex',
    },
  });

  return items.map((item, index) => (
    <UniversalContainer
      {...itemContainerConfig(item)}
      key={`${item?.$unique_key ?? ''}_${index}`}
      style={{ position: 'relative' }}
    >
      {outputGridItemIndicator && (
        <span data-testid="grid-indicator" className={styles.gridItemIndicator}>
          {index + 1}
        </span>
      )}
      <ItemComponents
        key={`${item?.$unique_key ?? ''}_${index}`}
        components={item?.itemComponents}
        disableDefaultProps={disableDefaultProps}
        isBuilderPage={isBuilderPage}
        outputDashedBorder={outputDashedBorder}
        fitWidth={fitWidth}
      />
    </UniversalContainer>
  ));
};

GridItems.propTypes = {
  items: P.array,
  disableDefaultProps: P.bool,
  isBuilderPage: P.bool,
  outputGridItemIndicator: P.bool,
  outputDashedBorder: P.bool,
};

GridItems.defaultProps = {
  items: [],
};

ItemComponents.propTypes = {
  components: P.array,
  outputDashedBorder: P.bool,
};

export default GridItems;
